/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

/* Components */
import Buttons from './Buttons';
import Title from './Title';
import Subtitle from './Subtitle';
import Description from './Description';

/* Utils */
import { ImageRatio } from '../../utils/constants';

/* Hooks */
import useImageCard from '../../hooks/useImageCard';

/* Style */
import './DetailContainer.scss';

const IMG_WIDTH = 1980;
const IMG_DIMENSION = ImageRatio.SIXTEEN_BY_NINE;

function DetailContainer({
  content,
  children,
  className,
  isScrolled,
}) {
  const {
    images,
    title,
  } = content || {};

  const { imageUrl } = useImageCard({
    images,
    imageSize: IMG_WIDTH,
    aspectRatio: IMG_DIMENSION,
  });

  return (
    <div className={`dtv-html5-c-detail-container ${className} ${isScrolled ? 'dtv-html5-c-detail-container--scrolled' : ''}`}>
      <img className="dtv-html5-c-detail-container__image" src={imageUrl} alt={title} />
      <div className="dtv-html5-c-detail-container__content">
        {children}
      </div>
    </div>
  );
}

DetailContainer.propTypes = {
  children: PropTypes.node.isRequired,
  content: PropTypes.shape({
    title: PropTypes.string,
    images: PropTypes.instanceOf(Map),
  }),
  className: PropTypes.string,
  isScrolled: PropTypes.bool,
};

DetailContainer.defaultProps = {
  content: {
    title: '',
    images: Map(),
  },
  className: '',
  isScrolled: false,
};

const DetailContainerMemo = memo(DetailContainer);

DetailContainerMemo.Title = Title;
DetailContainerMemo.Subtitle = Subtitle;
DetailContainerMemo.Description = Description;
DetailContainerMemo.Buttons = Buttons;

export default DetailContainerMemo;
